import { Box, Select, Option, Typography } from "@mui/joy";
import { useEffect, useState } from "react";
import { CornerDownLeft } from "lucide-react";

interface IEaveDripEdge {
    value: string | null;
    onChange: (value: string) => void;
    loading?: boolean;
}

export function EaveDripEdge(props: IEaveDripEdge) {
    const { value, onChange, loading } = { ...props };
    const [eaveDripEdge, setEaveDripEdge] = useState<string | null>(null);

    const handleUpdate = (event: any, newValue: string | null) => {
        if (loading) return;
        const selectedValue = newValue || "";
        setEaveDripEdge(selectedValue);
        onChange(selectedValue);
    };

    useEffect(() => {
        if (value) {
            setEaveDripEdge(value);
        }
    }, [value]);

    return (
        <Box flex={1}>
            <Typography level="body-sm" sx={{ fontWeight: "md", mb: 0.5 }}>
                Eave Drip Edge
            </Typography>

            <Select
                placeholder="Select eave drip edge"
                value={eaveDripEdge}
                onChange={handleUpdate}
                disabled={loading}
                startDecorator={<CornerDownLeft size={16} />}
                slotProps={{ listbox: { sx: { zIndex: 10001 } } }}
            >
                <Option value="2*2">2*2</Option>
                <Option value="2*4">2*4</Option>
            </Select>
        </Box>
    );
}
